/** API 응답 껍질 벗기기.
 *
 * 서버가 { data: { data: ... } } 로 한 겹 더 감싸 주는 곳과 그렇지 않은 곳이
 * 섞여 있어, 화면마다 `res?.data?.data || res?.data` 를 각자 적어 왔습니다.
 * 같은 판단을 여러 벌 두면 한쪽만 고쳐질 뿐이라 여기 한 곳에 둡니다.
 */

/** 감싼 껍질을 벗겨 알맹이를 돌려줍니다. */
export const unwrapData = <T = any>(res: any): T | undefined =>
    (res?.data?.data ?? res?.data) as T | undefined;

/** 알맹이가 배열일 때만 돌려주고, 아니면 빈 배열. 목록 조회에 씁니다. */
export const unwrapList = <T = any>(res: any): T[] => {
    const body = unwrapData(res);
    return Array.isArray(body) ? (body as T[]) : [];
};

/**
 * 요청이 성공했는가.
 *
 * onRequest 는 예외를 던지지 않고 error.response 를 그대로 돌려줍니다. 그래서
 * await 뒤에 상태를 직접 봐야 실패를 압니다. 보지 않으면 실패가 성공처럼
 * 지나갑니다 — 서브 장소가 "오류도 없이" 목록에서만 사라지던 원인입니다.
 *
 * status 가 없는 응답(mock 등)은 성공으로 봅니다. 예전 동작과 같습니다.
 */
export const isOkResponse = (res: any): boolean => {
    const s = res?.status;
    return s == null || (typeof s === 'number' && s >= 200 && s < 300);
};

/** 서버가 준 사람이 읽을 만한 실패 문구. 없으면 undefined — 부르는 쪽이 기본 문구를 씁니다. */
export const errorMessageOf = (res: any): string | undefined => {
    const m = res?.data?.message;
    return typeof m === 'string' && m.trim() ? m : undefined;
};
